import { gql } from '@apollo/client';

export const SEARCH_BY_EAN = gql`
  query searchByEan($ean: String!) {
    searchByEan(ean: $ean) {
      entity_id
      entity_type
    }
  }
`;

export const TARIFF_GRID = gql`
  query tariffGrid($input: TariffGridInput!) {
    tariffGrid(input: $input) {
      id
      title
      duration
      cost
      time_from
      time_to
      use_global_discounts
      has_fixed_finish_time
      per_minute
    }
  }
`;

export const SERVICES = gql`
  query services($input: ServicesInput!) {
    services(input: $input) {
      id
      title
      cost
      wholesale_cost
      tax_percent
      use_global_discounts
      created_at
      vat
      tax_system
    }
  }
`;

export const GOODS = gql`
  query goods($input: GoodsInput!) {
    goods(input: $input) {
      id
      title
      cost
      amount
      use_global_discounts
      use_fair_sign
      vat
      tax_system
    }
  }
`;
